import React from "react"
import Element from "@bappweb/element"
import Block from "@bappweb/block"
import Image from "@bappweb/image"

const QrCode = () => {
  return(
      <Block className = "qr-inner" >
        <Element type="h3">QR Kod İle İndirin</Element>
        <Block className="qr-content">
            <Element type="p">
                {"QR kodu okutun, Akbank Mobil'i"} <br /> {"kolayca indirin."}
            </Element>
            <Image path={"./img/mobiluygulama/qr-code.png"} className="landing-header-img" />
        </Block>
      </Block>
    )
}

export default QrCode
